import { jsx as a } from "react/jsx-runtime";
import "react";
var t = (r) => /* @__PURE__ */ a("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21",
  ...r,
  children: /* @__PURE__ */ a("path", {
    fill: "#090909",
    stroke: "currentColor",
    d: "M17.628 8.5a.37.37 0 0 0 .344-.23.375.375 0 0 0 .028-.144V2.848a.351.351 0 0 0-.075-.199.359.359 0 0 0-.289-.147H12.41a.37.37 0 0 0-.378.22.375.375 0 0 0 .378.524h4.349l-4.61 4.618a.365.365 0 0 0 0 .525.363.363 0 0 0 .522 0l4.59-4.618v4.375a.375.375 0 0 0 .367.354ZM2.372 12.5a.37.37 0 0 0-.344.23.376.376 0 0 0-.028.144v5.278c.004.072.03.142.075.199a.358.358 0 0 0 .289.147H7.59a.37.37 0 0 0 .41-.372.376.376 0 0 0-.256-.355.368.368 0 0 0-.154-.017H3.241l4.61-4.618a.367.367 0 0 0 0-.525.361.361 0 0 0-.522 0L2.74 17.23v-4.375a.375.375 0 0 0-.367-.354Z"
  })
});
export {
  t as default
};
